import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  transactionData: [],
  totalTransaction: 0,
  transactionDetails: {}
}

export const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {
    setTransactionData(state, { payload }) {
      state.transactionData = payload.result
      state.totalTransaction = payload.total
    },
    setTransactionDetailsData(state, { payload }) {
      state.transactionDetails = payload
    },
  }
})

export const { setTransactionData, setTransactionDetailsData } = transactionSlice.actions;

export default transactionSlice.reducer;

export function getTransaction(limit, offset, keyword, fromDate, toDate, type) {
  return async function getTransactionThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getTransaction(limit, offset, keyword, fromDate, toDate, type).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setTransactionData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function getTransactionDetails(id) {
  return async function getTransactionThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getTransactionDetails(id).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setTransactionDetailsData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}




